<div class="form-group" (blur)="onTouched()">
  <label>Distributions</label>
  <ep-distribution-selector #distributionSelector
    [isReadOnly]="disabled"
    (selectedDistributionIdChange)="selectedDistributionIdChange($event)" [showFallbackDistributions]="showFallbackDistributions">
  </ep-distribution-selector>

  @if ((distributions$ | async); as distributions) {
    <div class="mt-1 list-group">
      @if (distributions?.length) {
        @for (distribution of distributions; track distribution) {
          <div class="list-group-item" [class.disabled]="disabled">
            @if (!disabled) {
              <a class="badge" (click)="remove(distribution.DistributionsId)"
              role="button">&times;</a>
            }
            <p class="list-group-item-header header text-center">
              <strong>{{distribution.DocumentConfigIn?.DocumentType?.DistributionObject?.Name}}</strong>
              (<em>{{distribution.DistributionsId}}</em>)
            </p>
            <div class="row">
              <div class="col-md-6">
                <p class="list-group-item-text">
                  {{distribution.PartnerIn?.PartnerName}} ({{distribution.PartnerIn?.PartnerType?.Name}})
                </p>
                <p class="list-group-item-text">
                  {{distribution.DocumentConfigIn?.Format?.FormatName}}/
                  {{distribution.DocumentConfigIn?.Variant?.VariantName}}/
                  {{distribution.DocumentConfigIn?.VariantVersion?.VariantVersionName}}
                </p>
                @if (distribution.TransportConfigurationIn?.Name) {
                  <p class="list-group-item-text">
                    {{distribution.TransportConfigurationIn?.Name}}
                  </p>
                }
              </div>
              <div class="col-md-6">
                <p class="list-group-item-text">
                  {{distribution.PartnerOut?.PartnerName}} ({{distribution.PartnerOut?.PartnerType?.Name}})
                </p>
                <p class="list-group-item-text">
                  {{distribution.DocumentConfigOut?.Format?.FormatName}}/
                  {{distribution.DocumentConfigOut?.Variant?.VariantName}}/
                  {{distribution.DocumentConfigOut?.VariantVersion?.VariantVersionName}}
                </p>
                @if (distribution.TransportConfigurationOut?.Name) {
                  <p class="list-group-item-text">
                    {{distribution.TransportConfigurationOut?.Name}}
                  </p>
                }
              </div>
            </div>
          </div>
        }
      } @else {
        <div class="list-group-item disabled">
          <p class="list-group-item-text">&nbsp;</p>
          <p class="list-group-item-text text-center">
            <em>List is empty</em>
          </p>
          <p class="list-group-item-text">&nbsp;</p>
        </div>
      }
    </div>
  } @else {
    <div class="list-group-item disabled">
      <p class="list-group-item-text">&nbsp;</p>
      <p class="list-group-item-text text-center">
        <em>Loading...</em>
      </p>
      <p class="list-group-item-text">&nbsp;</p>
    </div>
  }


</div>
